<template>
  <v-dialog v-model="dialog" width="800px">
    <template v-slot:activator="{ on }">
      <mf-button label="Selecionar números do whatsapp" v-on:click.native="on.click" />
    </template>
    <v-card class="exclusao">
      <v-card-title>Selecionar números do Whatsapp</v-card-title>
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col class="pl-6 pr-6 py-2">
            <mf-search v-model.lazy="delaySearch" placeholder="Buscar número" hide-details />
          </v-col>
        </v-row>
        <v-data-table
          v-model="localSelectedWhatsappNumbers"
          :items="filteredItems"
          :headers="headers"
          :items-per-page="5"
          :options.sync="options"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, -1] }"
          item-key="number"
          show-select
        >
          <template v-slot:header.data-table-select="{ on, props }">
            <v-simple-checkbox color="primary" v-bind="props" v-on="on"></v-simple-checkbox>
          </template>
          <template v-slot:item="props">
            <tr>
              <td>
                <v-simple-checkbox color="primary" :value="props.isSelected" @input="props.select($event)"></v-simple-checkbox>
              </td>
              <td>
                <mf-icon fill :color="statusColor(props.item.connection_status)">fiber_manual_record</mf-icon>
                {{ statusText(props.item.connection_status) }}
              </td>
              <td>
                <v-tooltip v-if="props.item.name.length > 22" max-width="250" top>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ getFormatedText(props.item.name) }}</span>
                  </template>
                  <span>{{ props.item.name }}</span>
                </v-tooltip>
                <span v-else>
                  {{ props.item.name }}
                </span>
              </td>
              <td>
                {{ phoneNumberFormat(props.item.number) }}
              </td>
            </tr>
          </template>
        </v-data-table>

        <mf-action-buttons
          class="pa-3"
          :primary-button="{
            text: 'Salvar seleção de números',
            action: selectWhatsappNumbers,
            isVisible: true,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: closeDialog,
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import truncate from 'lodash/truncate'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'
import { diacriticSpaceSensitiveRegex } from '@/helpers/search.js'
import { phoneNumberFormat } from '@/helpers/phoneNumberFormat.js'
import { QUERY_GET_NUMBERS } from '@/modules/campanhas/whatsapp/graphql/index.js'
export default {
  props: {
    selectedWhatsappNumbers: {
      type: Array,
    },
  },
  data: () => ({
    dialog: false,
    items: [],
    options: {},
    localSelectedWhatsappNumbers: [],
    filteredItems: [],
    delaySearch: '',
  }),
  computed: {
    headers() {
      return [
        {
          text: 'Status',
          value: 'connection_status',
          sortable: true,
          width: '20%',
        },
        {
          text: 'Nome',
          value: 'name',
          sortable: true,
          width: '50%',
        },
        {
          text: 'Número',
          value: 'number',
          sortable: true,
          width: '30%',
        },
      ]
    },
  },
  apollo: {
    numbers: {
      query: QUERY_GET_NUMBERS,
      update({ getNumbers }) {
        this.items = getNumbers
        this.filteredItems = getNumbers
        return getNumbers
      },
    },
  },
  watch: {
    selectedWhatsappNumbers: {
      deep: true,
      handler(val) {
        if (!isEqual(val, this.localSelectedWhatsappNumbers)) {
          this.localSelectedWhatsappNumbers = cloneDeep(val)
        }
      },
    },
    delaySearch(value) {
      this.filteredItems = this.filterItems(value)
      this.options.page = 1
    },
    dialog() {
      this.options.page = 1
    },
  },
  mounted() {
    this.localSelectedWhatsappNumbers = cloneDeep(this.selectedWhatsappNumbers)
  },
  methods: {
    phoneNumberFormat,
    filterItems(value) {
      if (!value) return this.items
      const searchRegex = diacriticSpaceSensitiveRegex(value)
      return this.items.filter((item) => item.name.match(searchRegex) || item.number.includes(value))
    },
    statusText(status) {
      if (status === 'ONLINE') return 'Online'
      if (status === 'OFFLINE') return 'Offline'
      if (status === 'INACTIVE') return 'Indisponível'
      return 'Conectando'
    },
    statusColor(status) {
      if (status === 'ONLINE') return '#26a95d'
      if (status === 'OFFLINE') return '#e74c3c'
      if (status === 'INACTIVE') return '#d2d6d9'
      return '#ffe336'
    },
    getFormatedText(text) {
      return truncate(text, {
        length: 23,
        separator: ' ',
      })
    },
    selectWhatsappNumbers() {
      this.$emit('update:selected-whatsapp-numbers', this.localSelectedWhatsappNumbers)
      this.dialog = false
    },
    closeDialog() {
      this.dialog = false
    },
  },
}
</script>
